interface props {
  placeholder: string;
  value?: string | number;
  maxLength?: number;
  minLength?: number;
  setInputText?: Function;
  isRequired?: boolean;
  disabled?: boolean;
  onFocus?: Function;
  type?: string
}
function InputField({
  placeholder,
  value,
  maxLength,
  minLength,
  setInputText,
  disabled,
  onFocus,
  type,
}: props) {
  return (
    <input
      type={type === "password" ? "password" : "text"}
      placeholder={placeholder}
      value={value}
      className="form-control"
      onChange={(value) => setInputText && setInputText(value.target.value)}
      maxLength={maxLength}
      minLength={minLength}
      disabled={disabled}
      onFocus={(e) => onFocus && onFocus(e)}
    />
  );
}

export default InputField;
